/* eslint-disable @next/next/no-img-element */
import classNames from "classnames";
import Link from "next/link";
import React, { useEffect, useState } from "react";

import Image from "next/image";

import Splash from "assets/home/splash.jpg";
import Stars from "assets/home/stars.svg";
import HeroRaycastFrame from "assets/home/hero-raycast-frame.png";

import Container from "components/Container";

import styles from "./Hero.module.css";
import HeroDownloadInfo from "./HeroDownloadInfo";

const Hero: React.FC<{ latestVersion: string }> = ({ latestVersion }) => {
  const [transitionStarted, setTransitionStarted] = useState(false);

  useEffect(() => {
    setTimeout(() => setTransitionStarted(true), 10);
  }, []);

  return (
    <section className={classNames(styles.hero, { [styles.active]: transitionStarted })}>
      <div className={styles.heroBackground}>
        <div className={styles.heroBackgroundInner}>
          <Image
            src={Splash}
            priority
            unoptimized
            layout="fill"
            objectFit="contain"
            alt="Stylistic background splash to pretty up the page"
          />
        </div>
        <Stars className={styles.stars} />
      </div>
      <div className={styles.heroRaycastFrame}>
        <Image
          src={HeroRaycastFrame}
          alt="Example of what Raycast looks like"
          layout="fill"
          objectFit="contain"
          priority
        />
      </div>

      <Container>
        <div className={classNames(styles.heroBody)}>
          <h1 className={styles.heroTitle} style={{ marginTop: "clamp(-30px, calc(-7vw + 57px), 35px)" }}>
            <em>Supercharged</em> productivity
          </h1>
          <p className={styles.heroSubtitle}>
            Raycast is a blazingly fast, totally extendable launcher. It lets you complete tasks, calculate, share
            common links, and much more.
          </p>

          <HeroDownloadInfo fadeInEnabled transitionStarted={transitionStarted} latestVersion={latestVersion} />

          <div className={styles.announcementOuter}>
            <div className={styles.announcement}>
              <div>
                <h3>Say hello to community stories</h3>
                <p>
                  Hear from our users in the community how they&rsquo;re using Raycast to speed up their producitivity
                </p>
              </div>
              <Link href="/community-stories">
                <a className={styles.readMore}>
                  <span>View Stories</span>
                  <i>→</i>
                </a>
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Hero;
